var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"#","list-type":"picture-card","http-request":_vm.imgUpload,"on-remove":_vm.handleRemove,"file-list":_vm.fileList,"limit":_vm.limit}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }